/**
 * RTK Query tag type constants.
 * Use these constants instead of string literals for type safety and consistency.
 */

export const Tag = {
  ApiKeys: "ApiKeys",
  AuthStatus: "AuthStatus",
  CurrentUser: "CurrentUser",
  MyProjects: "MyProjects",
  Relays: "Relays",
  SpendCap: "SpendCap",
  IrohNodes: "IrohNodes",
} as const

export type TagType = (typeof Tag)[keyof typeof Tag]
